"use client";

interface ComparisonItem {
  metric: string;
  before: string;
  after: string;
  improvement: string;
}

const comparisonData: ComparisonItem[] = [
  { metric: 'Network Performance Visibility', before: 'Delayed reports', after: 'Real-time', improvement: 'Instant' },
  { metric: 'Subscriber Churn Prediction', before: 'Reactive', after: 'Predictive', improvement: '40% ↑ accuracy' },
  { metric: 'Revenue Leakage Detection', before: 'Monthly audits', after: 'Real-time alerts', improvement: '70% ↓' },
  { metric: 'Network Investment Decisions', before: 'Quarterly reviews', after: 'Continuous insights', improvement: 'Faster' },
  { metric: 'Manual Reporting Hours/Week', before: '50 hours', after: '6 hours', improvement: '88% ↓' },
  { metric: 'Subscriber Analytics', before: 'Limited', after: 'Full 360° view', improvement: 'Complete' },
];

export default function TelecomFinancialImpactSection() {
  return (
    <section className="py-14 sm:py-20 lg:py-24 bg-white px-4 sm:px-6 lg:px-8 xl:px-12 w-full md:min-h-screen md:flex md:items-center">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-serif text-navy text-2xl sm:text-3xl md:text-4xl xl:text-[3rem] leading-[1.2] font-bold mb-6">
            What Telecom Data Fragmentation <span className="italic">Costs Operators</span>
          </h2>
        </div>

        <div className="max-w-5xl mx-auto mb-12">
          <div className="bg-cream rounded-2xl p-8 md:p-10 border border-gray-200">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b-2 border-navy">
                    <th className="text-left py-4 px-4 font-serif text-navy text-lg font-bold">METRIC</th>
                    <th className="text-left py-4 px-4 font-serif text-navy text-lg font-bold">BEFORE EDW</th>
                    <th className="text-left py-4 px-4 font-serif text-navy text-lg font-bold">AFTER EDW</th>
                    <th className="text-left py-4 px-4 font-serif text-navy text-lg font-bold">IMPACT</th>
                  </tr>
                </thead>
                <tbody>
                  {comparisonData.map((item, index) => (
                    <tr key={index} className="border-b border-gray-200 hover:bg-white/50 transition-colors">
                      <td className="py-4 px-4 text-charcoal font-medium">{item.metric}</td>
                      <td className="py-4 px-4 text-red-600">{item.before}</td>
                      <td className="py-4 px-4 text-green-600 font-medium">{item.after}</td>
                      <td className="py-4 px-4">
                        <span className="inline-block bg-gold/10 text-gold text-xs font-bold uppercase tracking-wider px-3 py-1 rounded">
                          {item.improvement}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-gold to-gold/80 rounded-2xl p-8 md:p-10 shadow-xl">
            <div className="text-center mb-6">
              <h3 className="font-serif text-navy text-3xl md:text-4xl font-bold mb-4">ROI Example</h3>
              <p className="text-navy/80 text-lg leading-[1.6] mb-6">For a telecom operator with 5 million subscribers:</p>
            </div>
            <div className="space-y-3 mb-6">
              <div className="bg-white/90 rounded-xl p-4">
                <p className="text-charcoal text-base"><span className="font-bold text-navy">Reducing churn by 1%</span> = <span className="text-gold font-bold">₹50+ crore annual revenue retention</span></p>
              </div>
              <div className="bg-white/90 rounded-xl p-4">
                <p className="text-charcoal text-base"><span className="font-bold text-navy">Reducing revenue leakage by 3%</span> = <span className="text-gold font-bold">₹75+ crore recovered revenue</span></p>
              </div>
              <div className="bg-white/90 rounded-xl p-4">
                <p className="text-charcoal text-base"><span className="font-bold text-navy">Reducing manual reporting</span> = <span className="text-gold font-bold">44 hours/week saved</span></p>
              </div>
            </div>
            <p className="text-navy/70 text-sm text-center font-medium">Typical EDW payback period: <span className="text-navy font-bold">12–18 months</span></p>
          </div>
        </div>
      </div>
    </section>
  );
}
